import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

/**
 * The local projection of `subscriptions`: every plan the active organization holds, open or not.
 *
 * Read-only on the device. Plans change through Stripe and the billing endpoints, never through the
 * upload queue, so nothing here is ever written locally.
 *
 * An organization can hold several rows at once — a free row beside a paid one, a cancelled plan
 * beside its replacement, and a few accounts still billed per boat with two paid plans. Which one
 * counts is `pickCountingSubscription`'s business, not the table's.
 *
 * Mirrors the `subscriptions` query in `sync-streams.yaml` column for column; the test beside the
 * `boat_details` schema explains why both directions matter.
 */
export const subscriptions = sqliteTable('subscriptions', {
  /** The Laravel id. The stream sends it as-is, and PowerSync keeps every `id` as text. */
  id: text('id').notNull().primaryKey(),
  name: text('name'),
  /** `stripe_plan` on the server: `free`, `essentials`, `plus` or `pro`. */
  plan: text('plan'),
  /** Above 1 only for an account still billed per boat (MDC-4516). */
  quantity: integer('quantity'),
  trial_ends_at: text('trial_ends_at'),
  /** Set when renewal is cancelled: the plan runs until then. */
  ends_at: text('ends_at'),
  /** A legacy boolean that says nothing about billing. Read `stripe_status`. */
  status: integer('status'),
  /** Stripe's own status: `active`, `trialing`, `past_due`, `unpaid`, `canceled`, `incomplete`… */
  stripe_status: text('stripe_status'),
  next_billing_date: text('next_billing_date'),
});
